import React from 'react';

import { CompanyModel } from '../../../../../typings/api/skymap/rest/v0/.common';
import { useErrorHandling } from '../../hooks/use-error-handling';
import { Stack } from '../stack/stack';
import { ApiRequestPath } from './buy-design-license-dialog';
import { Form } from './form';
import { useBuyQuery } from './use-buy-query';

type Props = {
  buildErrorList: ReturnType<typeof useErrorHandling<ApiRequestPath>>['buildErrorList'];
  buyQuery: ReturnType<typeof useBuyQuery>;
  company: CompanyModel;
  formDisabled: boolean;
  getErrorForPath: ReturnType<typeof useErrorHandling<ApiRequestPath>>['getErrorForPath'];
};

const DialogContent = (props: Props) => {
  const { excludeErrorPaths } = useErrorHandling<ApiRequestPath>();

  return (
    <Stack spacing={0.5}>
      <Form
        company={props.company}
        disabled={props.formDisabled || props.buyQuery.isPending}
        getErrorForPath={props.getErrorForPath}
        id="designLicenseForm"
        onSubmit={props.buyQuery.mutate}
      />
      {props.buildErrorList({
        filter: excludeErrorPaths([
          'body.invoiceEmail',
          'body.invoiceReference',
          'body.invoiceTag',
        ]),
      })}
    </Stack>
  );
};

export { DialogContent };
